import {
  isEmpty,
  isEqual,
  xorWith
} from 'lodash'

export const isSame = (x, y) => isEmpty(xorWith(x, y, isEqual))
export const isDifferent = (x, y) => !isEmpty(xorWith(x, y, isEqual))
